export default "__VITE_ASSET__wG3EL9lk__"